import React, { useContext } from 'react';
import styled from 'styled-components';
import customerHeaderImg from '../../assets/img/customer/customerHeaderImg.png';
import UserContext from '../../Context/UserContext';
import { withRouter, NavLink } from 'react-router-dom';

const Header = styled.div`
  background: url(${(props) => props.back}) center no-repeat;
  text-align: center;
  width: 100%;
  background-size: cover;
`;

const Box = styled.div`
  margin: 0;
  padding: 100px 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  @media (max-width: 1080px) {
    padding: 50px 20px;
  }
  @media (max-width: 768px) {
    padding: 40px 20px;
  }
`;

const Title = styled.h1`
  @keyframes fadeInLeft {
    0% {
      opacity: 0;
      -webkit-transform: translateX(-20px);
      -ms-transform: translateX(-20px);
      transform: translateX(-20px);
    }
    100% {
      opacity: 1;
      -webkit-transform: translateX(0);
      -ms-transform: translateX(0);
      transform: translateX(0);
    }
  }

  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: fadeInLeft;
  animation-name: fadeInLeft;
  font-size: 36px;
  font-weight: 800;
  color: #ffffff;
  font-family: 'Montserrat', 'Noto Sans KR', sans-serif;
  padding-bottom: 10px;
  @media (max-width: 1080px) {
    font-size: 28px;
    line-height: 34px;
    padding-bottom: 10px;
  }
  @media (max-width: 768px) {
    font-size: 24px;
    line-height: 28px;
    padding-bottom: 10px;
  }
`;

const Desc = styled.p`
  @keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translateX(20px);
      -ms-transform: translateX(20px);
      transform: translateX(20px);
    }
    100% {
      opacity: 1;
      -webkit-transform: translateX(0);
      -ms-transform: translateX(0);
      transform: translateX(0);
    }
  }
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
  color: #eee;
  font-size: 15px;
  line-height: 22px;
  word-break: keep-all;
  @media (max-width: 1080px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

const SubMenu = styled.div`
  width: 100%;
  background: #001236;
  text-align: center;
  > div {
    width: 1200px;
    margin: 0 auto;
    @media screen and (max-width: 1280px) {
      width: 100%;
    }
    > ul {
      display: inline-block;
      vertical-align: top;
      list-style: none;
      @media (max-width: 768px) {
        padding: 0;
      }
      > li {
        float: left;
        border-left: 1px solid rgba(255, 255, 255, 0.2);
        height: 100%;
        > a {
          display: block;
          padding: 18px 40px;
          font-size: 17px;
          font-weight: 500;
          @media (max-width: 1080px) {
            padding: 15px 30px;
            font-size: 14px;
          }
          @media (max-width: 768px) {
            padding: 12px 25px;
            font-size: 13px;
          }
          @media (max-width: 480px) {
            padding: 10px 15px;
          }
        }
        :hover {
          background: #fff;
          > a {
            color: #001236;
          }
        }
      }
    }
  }
`;

const Item = styled.li`
  background-color: ${(props) => (props.current ? '#fff' : '#001236')};
`;

const Slink = styled(NavLink)`
  color: ${(props) => (props.current ? '#001236' : '#fff')};
`;

const EtcHeader = ({ location: { pathname } }) => {
  const { userData, setUserData } = useContext(UserContext);
  const currentToken = localStorage.getItem('auth-token');

  const subMenuArr =
    currentToken !== ''
      ? [
          { title: '개인처리방침', link: '/user/privacy' },
          { title: '회원정보수정', link: '/user/edit' },
        ]
      : [
          { title: '개인처리방침', link: '/user/privacy' },
          { title: '로그인', link: '/user/login' },
          { title: '회원가입', link: '/user/join' },
        ];
  console.log(pathname);
  return (
    <Header back={customerHeaderImg}>
      <Box>
        <Title>Member</Title>
        <Desc>회원가입을 통해 더욱 더 많은 서비스를 받으실 수 있습니다.</Desc>
      </Box>
      <SubMenu>
        <div>
          <ul>
            {subMenuArr.map((info, index) => (
              <Item key={index} current={pathname === info.link}>
                <Slink to={info.link} current={pathname === info.link}>
                  {info.title}
                </Slink>
              </Item>
            ))}
          </ul>
        </div>
      </SubMenu>
    </Header>
  );
};

export default withRouter(EtcHeader);
